module.exports = __webpack_public_path__ + "b02747bea0178e9d379613b6251321d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cylindre-laiton-poli.jpg
// module id = 678
// module chunks = 0